/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class SpacierArcadeSoundConfig implements ISoundConfig {

    public static instance:SpacierArcadeSoundConfig = new SpacierArcadeSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";
    COUNTUP_MULTI_1:string = "countUpMultiplier1";
    COUNTUP_MULTI_2:string = "countUpMultiplier2";

    MAIN_GAME_AMBIANCE:string = "background-music-main";
    RESPIN_AMBIANCE:string = "background-music-respin";

    REELS_SPIN_START?:string[] = ["reelsSpinning"];

    REELS_DEFAULT_BOUNCE:string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];

    WILD_LAND_BOUNCE:string = "wildLandBounce";
    WILD_MULTI_FINAL:string = "wildMultiFinal";
    WILD_MULTI_X1:string = "wildMultiX1";
    WILD_MULTI_X2:string = "wildMultiX2";
    WILD_MULTI_X3:string = "wildMultiX3";

    ANTICIPATION_SCATTER:string = "anticipationScatter";
    ANTICIPATION_FAIL_SCATTER:string = "anticipationFailScatter";

    WIN_TINY:string = "winTiny";
    WIN_SMALL:string = "winSmall";
    WIN_MEDIUM:string = "winMedium";
    WIN_LARGE:string = "winLarge";

    COUNTUP:string = "countUpLoop";
    COUNTUP_ENDS:string = "countUpEnds";

    BIG_WIN:string = "bigwin";
    BIG_WIN_COUNTUP:string = "bigwinCountup";
    BIG_WIN_LEVEL1:string = "bigwinLevel1";
    BIG_WIN_LEVEL2:string = "bigwinLevel2";
    BIG_WIN_LEVEL3:string = "bigwinLevel3";
    BIG_WIN_ENDS:string = "bigwinEnds";

    FS_INTRO:string = "fsIntro";
    FS_INTRO_CONTINUE:string = "fsIntroContinueButton";
    FS_ENDS_SWEEP:string = "fsEndsSweep";
    FS_OUTRO_CONTINUE:string = "fsOutroContinueButton";
    FS_ENDS:string = "fsEnds";

    FS_PLUS_SPIN:string = "fsPlusSpin";

    FS_REELS_HIGHLIGHT:string = "fsReelsHighlight";
    FS_WILD_ENTER:string = "fsWildsEnter";
    FS_SYMBOL_LOCKING:string = "fsSymbolsLocking";
    FS_RESPIN_HIT:string = "fsRespinHit";

    SCATTER_1:string = "scatter1";
    SCATTER_2:string = "scatter2";
    SCATTER_3:string = "scatter3";

    constructor() {
        if(SpacierArcadeSoundConfig.instance) {
            throw new Error("SpacierArcadeSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}